export default __webpack_public_path__ + "static/logo-10-9cacb66aefe9a215c70e9a62b08436ba.jpeg";